/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_All_Fit_DenyInputs */



/**
* | output |
* | --- |
* | "Use current settings" |
*
* @param {Render_All_Fit_DenyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_all_fit_deny = /** @type {((inputs?: Render_All_Fit_DenyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_All_Fit_DenyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser les réglages actuels")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Einstellungen verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa impostazioni attuali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущие настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar ajustes actuales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用当前设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の設定を使用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मौजूदा सेटिंग्स का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usar definições atuais")
	return /** @type {LocalizedString} */ ("Use current settings")
});